import awsConfigProd from './aws-exports.prod'
import awsConfig from './aws-exports'

const MODE = (~location.origin.indexOf('.waterguru.com') || ~location.origin.indexOf('.waterguru-prod.com') && process.env.NODE_ENV === 'production') ? 'prod' : 'qa'
const CONFIG = (MODE === 'prod') ? awsConfigProd : awsConfig
const WEBAPP_URL = 'webapp.' + location.host.split('.').slice(location.host.split('.').length - 2).join('.')

export { MODE, WEBAPP_URL }
export default CONFIG
